<div class="tt-c-rating">
  <div v-if="includeAccessibleText" class="tt-u-clip-hide" v-html="$msg('ratingStars.rating', [rating])"></div>
  <div v-for="n in 5" class="tt-c-rating__star" :key="n">
    <tt-icon :name="starIcon(n)" class="tt-c-rating__icon" :size="starSize"></tt-icon>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/components/rating/rating-stars.html